import { type SearchView } from '@/types/schema/views/SearchView';
import { usePageEditorContext } from '@/pages/page/page-editor/PageEditorContext';
import { SearchInputsSortable } from './SearchInputsSortable';

interface SearchInputsSortableWrapperProps {
  view: SearchView;
  children: React.ReactNode;
}

export function SearchInputsSortableWrapper({ view, children }: SearchInputsSortableWrapperProps) {
  const { selectedItem } = usePageEditorContext();

  if (!selectedItem || selectedItem.type !== 'view') {
    return children;
  }

  if (selectedItem.view.key === view.key) {
    return <SearchInputsSortable view={view} />;
  }

  return children;
}
